module.exports = __webpack_public_path__ + "img/rizhi.e7ac01ae.svg";